import { API } from 'aws-amplify'

import { ChannelType, ISubscription } from 'types'

export const updateSubscription = async (subscription: any) =>
  API.post('BOC_API', '/updateiotuser', {
    headers: {},
    body: subscription
  })

export const getSubscription = async () => {
  const resp = await API.get('BOC_API', '/getiotuser', {
    headers: {}
  })

  if (resp.messageStatus === 'error') {
    throw new Error(resp.messageCode)
  }
  const usertype=resp.usertype || {}
  const user = resp.data || {}
//email subscription
  const emailSubscription = (user.targets && user.targets.find((target: ISubscription) => target.type === ChannelType.EMAIL)) || {
    type: ChannelType.EMAIL,
    optOut: 'ALL'
  }
//sms subscription
  const smsSubscription = (user.targets && user.targets.find((target: ISubscription) => target.type === ChannelType.SMS)) || {
    type: ChannelType.SMS,
    optOut: 'ALL'
  }

  return {
    emailSubscription,
    smsSubscription,
    workinghours:user.workinghours,
    isalarmnotification:user.isalarmnotification,
    isleveldropnotification:user.isleveldropnotification,
    time: user.time,
    usertype : usertype
  }
}
